import { render, staticRenderFns } from "./VariationVideo.vue?vue&type=template&id=36a12e58&"
import script from "./VariationVideo.vue?vue&type=script&lang=js&"
export * from "./VariationVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports